// Timecode links in the call summary. The pipeline stores the overview with
// each resolved reference as "[@<seconds>]" (analysis.overview_timecodes, see
// data/dagster_calls_v2/assets/summary_timecodes.py).

const OVERVIEW_TIMECODE_RE = /\s*\[@(\d+(?:\.\d+)?)\]/g;

/**
 * Splits an overview into text and timecode parts, in order:
 *   "Retard [@10.5]. Fin." -> [{ text: "Retard" }, { seconds: 10.5 }, { text: ". Fin." }]
 */
export const splitOverviewTimecodes = (overview_timecodes) => {
  if (typeof overview_timecodes !== "string") return [];

  const parts = [];
  let last_index = 0;
  overview_timecodes.replace(OVERVIEW_TIMECODE_RE, (match, seconds, offset) => {
    if (offset > last_index) parts.push({ text: overview_timecodes.slice(last_index, offset) });
    parts.push({ seconds: Number(seconds) });
    last_index = offset + match.length;
    return match;
  });
  if (last_index < overview_timecodes.length) {
    parts.push({ text: overview_timecodes.slice(last_index) });
  }
  return parts;
};

/** "00:02:15,300" (SRT) -> 135.3, or null. */
export const srtTimeToSeconds = (srt_time) => {
  const match = /^(\d+):(\d{2}):(\d{2})[,.](\d{1,3})$/.exec((srt_time || "").trim());
  if (!match) return null;
  const [, hours, minutes, seconds, millis] = match;
  return (
    Number(hours) * 3600 +
    Number(minutes) * 60 +
    Number(seconds) +
    Number(millis.padEnd(3, "0")) / 1000
  );
};

/**
 * Call duration for display: 75 -> "1:15", 3725 -> "1:02:05".
 * Returns null when the duration is missing or not a positive number.
 */
export const formatCallDuration = (duration_seconds) => {
  const value = Number(duration_seconds);
  if (duration_seconds === null || duration_seconds === undefined || duration_seconds === "") {
    return null;
  }
  if (!Number.isFinite(value) || value <= 0) return null;

  const total = Math.round(value);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = String(total % 60).padStart(2, "0");

  if (hours > 0) return `${hours}:${String(minutes).padStart(2, "0")}:${seconds}`;
  return `${minutes}:${seconds}`;
};
